import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FiltroComunicados from '../../Filtros/FiltroComunicados';
import InfoComponent from '../InfoComponent';

class RelatorioCircunstanciado extends Component { 
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"relatorio-circunstanciado"} page={'relatorio-circunstanciado'}></InfoComponent>

					{/* Content page */}				{/* ObterCircunstanciado */}	
					<ErrorBoundary><FiltroComunicados url={"/ObterCircunstanciado"} urlFiltro={"/ObterCircunstanciado?"} /></ErrorBoundary>
					 
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RelatorioCircunstanciado;